module.exports = __webpack_public_path__ + "img/header-ccc.0226a2d.webp";